var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSnsTiktok = function SvgSnsTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.76 3.443A4.117 4.117 0 0 1 10.885 0H7.929l-.005 11.834a2.485 2.485 0 0 1-3.634 2.104 2.483 2.483 0 0 1-1.333-2.197 2.487 2.487 0 0 1 2.486-2.483c.256 0 .501.043.733.115V6.359a5.423 5.423 0 0 0-.733-.053C2.442 6.306 0 8.744 0 11.74c0 1.838.92 3.466 2.324 4.45.884.62 1.96.985 3.12.985 3 0 5.442-2.438 5.442-5.435V5.74A7.041 7.041 0 0 0 15 7.06V4.109a4.095 4.095 0 0 1-2.24-.665Z",
    fill: "current"
  })));
};
export default SvgSnsTiktok;